import axios from "axios";
import employees from "../../models/grupos/employees";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getEmployees(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/grupos/${data}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return employees.fromJson(item);
        });
      });
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const operid = localStorage.getItem("operId");

    let fecha = moment().format("YYYY-MM-DD");
    let payload = {
      operId: parseInt(operid, 10),
      fecha: fecha + "T00:00:00.000Z",
      grupoId: items.groupId,
      empId: items.empId,
      desde: items.from + "T00:00:00.000Z",
      hasta:
        items.to == undefined
          ? undefined
          : moment.utc(items.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      defaultGrp: items.defaultGrp,
    };

    return axios.post(`${url}/empgrupos`, payload, { headers });
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      fecha: data.oldFrom + "T00:00:00.000Z",
      desde: data.from + "T00:00:00.000Z",
      hasta:
        data.to == undefined
          ? undefined
          : moment.utc(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      haNoEx: data.to == undefined ? true : false,
      defaultGrp: data.defaultGrp,
    };

    return axios.patch(
      `${url}/empgrupos/${data.empId}&${data.groupId}&${data.oldFrom}`,
      payload,
      { headers }
    );
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const dateFrom = moment(data.from, "DD-MM-YYYY");
    let date = dateFrom.format("YYYY-MM-DD");

    return axios.delete(
      `${url}/empgrupos/${data.empId}&${data.grupoId}&${date}`,
      { headers }
    );
  }
}
export default service;
